import { useTranslation } from 'react-i18next';
import { Text } from '@lili/lili-frontend-common';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { FieldError } from '@Components/inputs/FieldError';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';

export const NonprofitOrganizationSizeForm = () => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col gap-[16px]'>
      <Text.H9>{t('organic.nonprofitOrganizationSize.subtitle')}</Text.H9>
      <ControllerWrapper name={EddEmbeddedFields.EDD_NONPROFIT_ORGANIZATION_SIZE}>
        {({ onChange, value, error }) => (
          <>
            <CustomRadioButton
              label={t('organic.nonprofitOrganizationSize.small')}
              value='1-5'
              inputId='small-nonprofit'
              onChange={onChange}
              checked={value === '1-5'}
              name={EddEmbeddedFields.EDD_NONPROFIT_ORGANIZATION_SIZE}
            />
            <CustomRadioButton
              label={t('organic.nonprofitOrganizationSize.medium')}
              value='6-20'
              inputId='medium-nonprofit'
              onChange={onChange}
              checked={value === '6-20'}
              name={EddEmbeddedFields.EDD_NONPROFIT_ORGANIZATION_SIZE}
            />
            <CustomRadioButton
              label={t('organic.nonprofitOrganizationSize.large')}
              value='20+'
              inputId='large-nonprofit'
              onChange={onChange}
              checked={value === '20+'}
              name={EddEmbeddedFields.EDD_NONPROFIT_ORGANIZATION_SIZE}
            />
            <FieldError
              error={error}
              testId={`${EddEmbeddedFields.EDD_NONPROFIT_ORGANIZATION_SIZE}-error`}
            />
          </>
        )}
      </ControllerWrapper>
    </div>
  );
};
